import React, { useEffect, useState } from "react";
import { db } from "../../config/firebase";
import { doc, getDoc, setDoc, onSnapshot, collection, addDoc, serverTimestamp } from "firebase/firestore";
import { toast } from "react-toastify";
import { useMyContext } from "../../context/MyContext";
import { Tooltip } from "antd";
import { useQueryClient } from "@tanstack/react-query";
import HistoryIcon from "./History";

const UpdateInvoiceNumber = () => {
  const { user } = useMyContext();
  const queryClient = useQueryClient();
  const [formData, setFormData] = useState({
    invoiceNumber_Prefix: "",
  });
  const [initialValue, setInitialValue] = useState("");

  useEffect(() => {
    const settingsDocRef = doc(db, "settings", "settings");
    
    // Set up real-time listener
    const unsubscribe = onSnapshot(settingsDocRef, (doc) => {
      if (doc.exists()) {
        const data = doc.data();
        setFormData(data);
        if (!initialValue) {
          setInitialValue(data.invoiceNumber_Prefix || "");
        }
      }
    }, (error) => {
      console.error("Error fetching settings data:", error);
      toast.error("Error fetching settings data. Please try again later.");
    });

    // Cleanup subscription
    return () => unsubscribe();
  }, [initialValue]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleAddData = async () => {
    try {
      // Only proceed if the value has changed
      if (initialValue !== formData.invoiceNumber_Prefix) {
        const settingsDocRef = doc(db, "settings", "settings");
        await setDoc(settingsDocRef, formData);
        
        // Add to history collection
        const historyCollectionRef = collection(db, "prefixHistory");
        await addDoc(historyCollectionRef, {
          prefixType: "Invoice Number Prefix",
          oldValue: initialValue,
          newValue: formData.invoiceNumber_Prefix,
          updatedBy: user?.name || user?.email || "Unknown user",
          updatedById: user?.uid,
          timestamp: serverTimestamp()
        });
        
        // Update the initial value to the new value
        setInitialValue(formData.invoiceNumber_Prefix);
        
        // Invalidate and refetch queries
        queryClient.invalidateQueries(['settings']);
        queryClient.invalidateQueries(['invoices']);
        
        toast.success("Invoice number prefix updated successfully!");
      } else {
        toast.info("No changes detected");
      }
    } catch (error) {
      console.error("Error updating invoice number prefix:", error);
      toast.error("Error updating invoice number prefix. Please try again later.");
    }
  };

  return (
    <div>
      <div className="w-full">
        <div className="flex flex-col gap-1 py-2">
          <div className="flex items-center justify-between">
            <label
              className="w-full text-sm font-normal"
              htmlFor="invoiceNumberPrefix"
            >
              Invoice Number Prefix Update
            </label>
            <HistoryIcon prefixType="Invoice Number Prefix" />
          </div>
          <input
            type="text"
            placeholder="Invoice Number Prefix"
            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
            id="invoiceNumber_Prefix"
            onChange={handleInputChange}
            value={formData.invoiceNumber_Prefix}
            name="invoiceNumber_Prefix"
            disabled={user?.role === "super admin" ? false : true}
          />
        </div>
        <Tooltip
          title={
            user?.role === "super admin"
              ? ""
              : "You cannot edit it in your current role"
          }
        >
          <button
            onClick={handleAddData}
            className={`px-8 py-2 rounded-lg text-sm text-[#fff] ${
              user?.role === "super admin"
                ? "bg-[#03336E]"
                : "cursor-not-allowed bg-gray-300"
            }`}
            disabled={user?.role === "super admin" ? false : true}
          >
            Update Invoice No
          </button>
        </Tooltip>
      </div>
    </div>
  );
};

export default UpdateInvoiceNumber;